import { axiosInstance, parseResult } from "./CommonApi";

export const getPolicies = async () => {
  const response = await axiosInstance.get(`/rtu/solaron-policy/`);
  return parseResult(response);
};

export const createPolicy = async (payload) => {
  const response = await axiosInstance.post(`/rtu/solaron-policy/`, payload);
  return parseResult(response);
};

export const updatePolicy = async (id, payload) => {
  const response = await axiosInstance.put(`/rtu/solaron-policy/${id}/`, payload);
  return parseResult(response);
};

export const deletePolicy = async (id) => {
  const response = await axiosInstance.delete(`/rtu/solaron-policy/${id}/`);
  return parseResult(response);
};
